import React from 'react';

import SearchDialogImpl from './SearchDialogImpl';
import { enhance } from './enhance';

export const SearchDialog = enhance(SearchDialogImpl);



// WEBPACK FOOTER //
// ./src/components/common/SearchDialog/index.jsx